(() => {
  const root = document.querySelector('.cart-v1-root');
  if (!root) return;

  const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  const moneyFormatCurrency = root.dataset.moneyFormatCurrency || moneyFormat;
  let localSubtotalCents = Number(root.dataset.subtotalCents || 0);
  // CART V2 : le Total affiché est cart.total_price (montant Shopify après remises).
  let localTotalCents = Number(root.dataset.totalCents || 0);

  // CART V2 — debounce réseau sur la quantité. Les clics rapides sur +/- ne
  // déclenchent qu'UN appel /cart/change.js ; l'UI, elle, réagit au clic.
  const QTY_DEBOUNCE_MS = 280;
  const pendingQty = new Map(); // lineKey -> { qty, timer }

  // CART V2 — barre CTA sticky mobile. Références capturées MAINTENANT : le
  // garde-fou ci-dessous peut déplacer l'hôte sous <body>, après quoi
  // root.querySelector ne la retrouverait plus.
  // BUG 2 (2026-08-13) — réconciliation INCRÉMENTALE de la liste, sans reload.
  // Identité de la section, lue dans le DOM : un template JSON génère un id du type
  // `template--21175541530785__main`, ce n'est PAS `cart-v1-page`. On l'extrait du
  // <section> englobant, ce qui évite de devoir toucher au Liquid.
  const sectionEl = root.closest('.shopify-section');
  const sectionId = sectionEl ? sectionEl.id.replace(/^shopify-section-/, '') : '';

  // '/cart' en EN, '/fr/cart' en FR. Jamais en dur : les pages FR ne suivent pas les EN.
  const localizedCartUrl = () => {
    let base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base + 'cart';
  };

  // Une seule tentative par composition de panier : garde anti-boucle si la section
  // rendue ne contenait pas la ligne attendue.
  let reconciling = false;
  let lastReconcileSignature = '';

  const stickyHost = root.querySelector('.js-cart-v1-sticky-host');
  const stickyBar = stickyHost ? stickyHost.querySelector('.js-cart-v1-sticky') : null;
  const stickyTotalEl = stickyBar ? stickyBar.querySelector('.js-cart-v1-sticky-total') : null;

  // CART V2 — formatage monétaire piloté par le GABARIT Shopify (data-money-format),
  // rendu côté serveur dans la devise active.
  // L'ancien repli `Intl.NumberFormat(undefined, {currency:'USD'})` avait deux défauts :
  //   1) il FORÇAIT USD — un client en CAD voyait ses montants étiquetés USD ;
  //   2) il suivait la locale du navigateur (fr-CA → « 1 732,00 » au lieu de « $1,732.00 »),
  //      donc l'affichage divergeait du rendu Liquid dès la première mise à jour.
  // `Shopify.formatMoney` n'est PAS défini sur ce thème (vérifié sur le preview), le repli
  // était donc le chemin normal, pas un cas limite.
  const formatWithTemplate = (cents, format) => {
    const value = Number(cents) || 0;
    const template = format || '${{amount}}';

    const number = (precision, thousands, decimal) => {
      const fixed = Math.abs(value / 100).toFixed(precision);
      const parts = fixed.split('.');
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + thousands);
      const sign = value < 0 ? '-' : '';
      return sign + whole + (parts[1] ? decimal + parts[1] : '');
    };

    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (_match, name) => {
      switch (name) {
        case 'amount': return number(2, ',', '.');
        case 'amount_no_decimals': return number(0, ',', '.');
        case 'amount_with_comma_separator': return number(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return number(0, '.', ',');
        case 'amount_with_apostrophe_separator': return number(2, "'", '.');
        case 'amount_with_space_separator': return number(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return number(0, ' ', ',');
        case 'amount_with_period_and_space_separator': return number(2, ' ', '.');
        default: return '';
      }
    });
  };

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return formatWithTemplate(cents, moneyFormat);
  };

  // P-PROMO : subtotal affiché AVEC devise (le reste des lignes reste sans code).
  const formatMoneyWithCurrency = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormatCurrency);
    }
    return formatWithTemplate(cents, moneyFormatCurrency);
  };

  const escapeAttr = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  };

  const rowByKey = (key) => root.querySelector(`.cart-page-item[data-line-key="${escapeAttr(key)}"]`);

  const setRowBusy = (row, busy) => {
    if (!row) return;
    row.querySelectorAll('.js-cart-v1-qty, .js-cart-v1-remove').forEach((el) => {
      if (busy) {
        el.setAttribute('disabled', 'disabled');
      } else {
        el.removeAttribute('disabled');
      }
    });

    // CART V2 — correctif : lever l'état « occupé » retirait `disabled` de TOUS les
    // boutons quantité, ce qui annulait updateButtonsState et laissait le « − »
    // cliquable alors que la ligne est déjà au minimum (et le « + » au maximum).
    // On re-dérive donc l'état du stepper depuis la quantité réellement affichée.
    // Les lignes cadeau n'ont pas de stepper (.js-cart-v1-qty-num absent) : on passe.
    if (!busy) {
      const qtyEl = row.querySelector('.js-cart-v1-qty-num');
      const qty = qtyEl ? Number(qtyEl.textContent) : 0;
      if (qty > 0) updateButtonsState(row, qty);
    }
  };

  const updateSubtotal = (cents, pulse = true) => {
    localSubtotalCents = Math.max(0, cents);
    root.dataset.subtotalCents = String(localSubtotalCents);
    const subtotalEl = root.querySelector('.js-cart-v1-subtotal');
    if (!subtotalEl) return;
    subtotalEl.textContent = formatMoneyWithCurrency(localSubtotalCents);
    if (pulse) {
      subtotalEl.classList.add('is-updating');
      window.setTimeout(() => subtotalEl.classList.remove('is-updating'), 300);
    }
  };

  // CART V2 — Total. Une seule écriture DOM, batchée dans le prochain frame avec
  // le reste (cf. updateSavingRow) : on ne mélange pas lecture et écriture.
  const updateTotal = (cents, pulse = true) => {
    localTotalCents = Math.max(0, cents);
    root.dataset.totalCents = String(localTotalCents);
    const text = formatMoneyWithCurrency(localTotalCents);

    const totalEl = root.querySelector('.js-cart-v1-total');
    if (totalEl) {
      totalEl.textContent = text;
      if (pulse) {
        totalEl.classList.add('is-updating');
        window.setTimeout(() => totalEl.classList.remove('is-updating'), 300);
      }
    }
    // stickyTotalEl est capturé au démarrage : la barre peut avoir été déplacée
    // sous <body> par le garde-fou position:fixed, donc root.querySelector ne la
    // trouverait plus.
    if (stickyTotalEl) stickyTotalEl.textContent = text;
  };

  // CART V2 — économie « bundle ». Le montant n'est JAMAIS recalculé à partir des
  // prix : on additionne les allocations de remise que Shopify a déjà posées sur
  // les lignes (la remise tapis + tapis de coffre est une remise AUTOMATIQUE au
  // niveau ligne). Donc ça suit la devise active sans rien coder en dur.
  // RÈGLE GWP : une ligne `_free_gift` au panier ⇒ 0 ⇒ chip masquée. Exactement la
  // même règle que le rendu Liquid, pour que les deux surfaces ne divergent pas.
  const computeSavings = (cart) => {
    let hasGift = false;
    let bundle = 0;
    let gift = 0;

    (cart.items || []).forEach((item) => {
      const props = item.properties || {};
      const allocated = (item.line_level_discount_allocations || []).reduce(
        (sum, alloc) => sum + Number((alloc && alloc.amount) || 0),
        0
      );
      // 26 sept 2026 : le chargeur est aussi reconnu par son produit (panier reconstruit depuis un courriel = sans _free_gift).
      if (props._free_gift || item.handle === 'gift-wireless-car-charger') {
        hasGift = true;
        gift += allocated;
      } else {
        bundle += allocated;
      }
    });

    return { bundle: hasGift ? 0 : bundle, gift };
  };

  // 26 sept 2026 — codes promo (ex. MYSTERY) : une ligne par code dans la liste des montants,
  // meme rendu que le Liquid, reconstruite a chaque retour de Shopify.
  const renderCodeRows = (cart) => {
    const host = root.querySelector('.js-cart-v1-code-rows');
    if (!host || !Array.isArray(cart.cart_level_discount_applications)) return;
    host.textContent = '';
    // /cart.js renvoie { title, total_allocated_amount } ; /cart/change.js renvoie
    // { amount, discount_application: { title, ... } } : on lit les deux formes.
    (cart.cart_level_discount_applications || []).forEach((raw) => {
      const d = (raw && raw.discount_application) || raw || {};
      const cents = Number((raw && raw.amount) || d.total_allocated_amount || 0);
      if (cents <= 0) return;
      const row = document.createElement('div');
      row.className = 'cart-total-row saving';
      const label = document.createElement('span');
      label.textContent = d.title || '';
      const val = document.createElement('span');
      val.className = 'cart-total-val';
      val.textContent = `−${formatMoney(cents)}`;
      row.append(label, val);
      host.append(row);
    });
  };

  const updateSavingRow = (selector, valueSelector, cents) => {
    const row = root.querySelector(selector);
    if (!row) return;
    const valueEl = row.querySelector(valueSelector);
    if (cents > 0) {
      if (valueEl) valueEl.textContent = `−${formatMoney(cents)}`;
      row.hidden = false;
    } else {
      row.hidden = true;
    }
  };

  const updateButtonsState = (row, qty) => {
    const minQty = Number(row.dataset.minQty || 1);
    const maxQtyRaw = row.dataset.maxQty;
    const maxQty = maxQtyRaw === '' ? null : Number(maxQtyRaw);

    const decBtn = row.querySelector('.js-cart-v1-qty[data-delta^="-"]');
    const incBtn = row.querySelector('.js-cart-v1-qty[data-delta]:not([data-delta^="-"])');

    if (decBtn) {
      decBtn.disabled = qty <= minQty;
    }

    if (incBtn) {
      incBtn.disabled = maxQty !== null && qty >= maxQty;
    }
  };

  // CART V2 — rendu des prix d'une ligne, MÊME priorité que le Liquid :
  //   1) remise panier  → on barre original_line_price (prix avant remise) ;
  //   2) sinon solde    → on barre compare_at × qté (comportement d'origine).
  // La somme des montants BARRÉS est ce qui fait le Subtotal (cart.original_total_price) :
  // c'est ce qui rend « Subtotal − remises = Total » vérifiable à l'œil.
  // Le « (Save X) » reste réservé au cas solde : sur une remise panier, la pastille promo
  // de la ligne annonce déjà le montant, l'afficher deux fois embrouille.
  const renderLinePrices = (row, finalLine, originalLine, compareLine) => {
    const block = row.querySelector('.cart-page-price-block');

    const finalEl = row.querySelector('.js-cart-v1-line-final');
    if (finalEl) finalEl.textContent = formatMoney(finalLine);

    let strike = 0;
    let strikeIsDiscount = false;
    if (originalLine > finalLine) {
      strike = originalLine;
      strikeIsDiscount = true;
    } else if (compareLine > finalLine) {
      strike = compareLine;
    }

    let compareEl = row.querySelector('.js-cart-v1-compare');
    if (strike > 0) {
      if (!compareEl) {
        compareEl = document.createElement('div');
        compareEl.className = 'cart-page-compare js-cart-v1-compare';
        block?.prepend(compareEl);
      }
      compareEl.textContent = formatMoney(strike);
      compareEl.style.display = '';
    } else if (compareEl) {
      compareEl.style.display = 'none';
    }

    let savingsEl = row.querySelector('.js-cart-v1-savings');
    if (strike > 0 && !strikeIsDiscount && strike - finalLine > 0) {
      if (!savingsEl) {
        savingsEl = document.createElement('div');
        savingsEl.className = 'cart-item-savings js-cart-v1-savings';
        block?.append(savingsEl);
      }
      savingsEl.textContent = `(Save ${formatMoney(strike - finalLine)})`;
      savingsEl.style.display = '';
    } else if (savingsEl) {
      savingsEl.style.display = 'none';
    }
  };

  const syncRowPrice = (row, cartItem) => {
    const compareUnit = Number(row.dataset.compareUnit || 0);
    renderLinePrices(
      row,
      cartItem.final_line_price,
      cartItem.original_line_price,
      compareUnit * cartItem.quantity
    );
  };

  // Réconcilie la LISTE des lignes avec le panier, en UNE passe DOM.
  // On récupère la section rendue par Shopify (GET, aucune mutation) et on en extrait les
  // lignes absentes : le balisage est donc identique à un rendu serveur (fitment, pastille
  // promo, prix barré, cadeau sans stepper), sans avoir à le dupliquer en JS.
  //
  // ORDRE DES OPÉRATIONS, capital : on place d'abord, on retire ensuite. Shopify RE-CLÉ une
  // ligne dès qu'une remise s'y attache — l'ajout du cadeau change la clé de la ligne tapis.
  // Retirer les lignes périmées AVANT le fetch viderait la liste pendant toute la requête
  // (~470 ms mesurés), soit exactement le clignotement qu'on cherche à supprimer.
  //
  // Aucun recâblage d'écouteurs : clics et clavier sont délégués sur `root`, le zoom
  // PhotoSwipe sur `document`. Le badge « INCLUDED » se pose seul, mk-gift.js observant
  // déjà .cart-page-items en MutationObserver (fichier partagé, non touché).
  const reconcileLines = async (cart) => {
    const container = root.querySelector('.cart-page-items');
    if (!container || !sectionId || reconciling) return false;

    reconciling = true;
    try {
      const url = `${localizedCartUrl()}?section_id=${encodeURIComponent(sectionId)}`;
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(`Section render failed: ${response.status}`);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

      // Ligne voulue pour chaque article : celle déjà à l'écran si sa clé n'a pas changé,
      // sinon celle fraîchement rendue par Shopify.
      const desired = [];
      cart.items.forEach((item) => {
        let row = rowByKey(item.key);
        if (!row) {
          const fresh = doc.querySelector(`.cart-page-item[data-line-key="${escapeAttr(item.key)}"]`);
          if (fresh) row = document.importNode(fresh, true);
        }
        if (row) desired.push(row);
      });
      if (!desired.length) return false;

      // Mise en place. `row === current` = déjà bien placée : on n'y touche pas, donc pas
      // de déplacement inutile ni de perte d'état (accordéon Perfect Fit resté ouvert).
      let ref = null;
      desired.forEach((row) => {
        const current = ref ? ref.nextElementSibling : container.firstElementChild;
        if (row !== current) container.insertBefore(row, current);
        ref = row;
      });

      // Retrait des lignes périmées, APRÈS la mise en place : à aucun instant la liste
      // n'est vide, et l'article déjà affiché ne disparaît jamais de l'écran.
      const cartKeys = new Set(cart.items.map((item) => item.key));
      Array.from(container.querySelectorAll('.cart-page-item')).forEach((row) => {
        if (!cartKeys.has(row.dataset.lineKey)) row.remove();
      });

      return true;
    } catch (error) {
      console.error(error);
      // Échec réseau : on relâche la garde pour qu'un prochain événement panier retente.
      // Pas de reload de secours — les montants affichés restent ceux de Shopify.
      lastReconcileSignature = '';
      return false;
    } finally {
      reconciling = false;
    }
  };

  const syncFromCart = (cart, options) => {
    const silent = !!(options && options.silent);
    if (!cart || !Array.isArray(cart.items)) return;

    if (cart.item_count === 0) {
      // Passage à l'état vide : ce balisage n'est pas dans le DOM, un rendu serveur est
      // nécessaire. Ce n'est PAS le reload supprimé ci-dessous — c'est une navigation de
      // fin de parcours. localizedCartUrl() et non '/cart' en dur : en FR on reste sur /fr/cart.
      window.location.href = localizedCartUrl();
      return;
    }

    const rowKeys = new Set(
      Array.from(root.querySelectorAll('.cart-page-item[data-line-key]')).map((row) => row.dataset.lineKey)
    );
    const cartKeys = new Set(cart.items.map((item) => item.key));


    // Une ligne NOUVELLE est apparue côté serveur. Deux causes réelles et vérifiées :
    //   1) Shopify SCINDE une ligne quand une remise ne couvre qu'une partie de la
    //      quantité (1 tapis + 1 tapis de coffre, tapis passé à 2 → 3 lignes renvoyées) ;
    //   2) le reconciler cadeau (mk-gift.js) ajoute la ligne GWP APRÈS le chargement.
    //
    // BUG 2 (2026-08-13) — ici se trouvait un window.location.reload(). Il garantissait
    // que la liste affichée = la liste facturée, mais au prix d'un rechargement complet du
    // document à chaque ajout du cadeau : le produit s'affichait, la page repartait de
    // zéro, puis tout se réordonnait. Clignotement et lenteur perçue.
    const hasUnrenderedLine = cart.items.some((item) => !rowByKey(item.key));
    const signature = cart.items.map((item) => item.key).join('|');

    if (hasUnrenderedLine) {
      // Suppression des lignes périmées DIFFÉRÉE à reconcileLines : les retirer ici
      // laisserait un trou pendant la requête (cf. re-clé de ligne par Shopify).
      if (signature !== lastReconcileSignature) {
        lastReconcileSignature = signature;
        // Non bloquant : les montants sont mis à jour juste en dessous — le sous-total ne
        // doit jamais attendre le réseau — puis la liste se complète d'elle-même.
        reconcileLines(cart).then((changed) => {
          if (!changed) return;
          syncFromCart(cart, options);
          // 1er nov 2026 : le redessin remet les lignes dans l'ordre brut de Shopify ; on replace
          // la finition sous son tapis et le chargeur sous les tapis.
          orderPersoRows();
        });
      }
    } else {
      // Rien à créer : on retire les lignes périmées tout de suite, sans risque de trou.
      rowKeys.forEach((key) => {
        if (!cartKeys.has(key)) {
          rowByKey(key)?.remove();
        }
      });
    }

    cart.items.forEach((item) => {
      const row = rowByKey(item.key);
      if (!row) return;
      row.dataset.finalUnit = String(item.final_price || 0);
      row.dataset.originalUnit = String(item.original_price || item.final_price || 0);

      // CART V2 : si un changement de quantité est encore en attente d'envoi pour
      // cette ligne (debounce), la valeur du serveur est déjà périmée — on ne
      // l'écrase pas par-dessus ce que l'utilisateur vient de cliquer.
      if (pendingQty.has(item.key)) {
        setRowBusy(row, false);
        return;
      }

      const qtyEl = row.querySelector('.js-cart-v1-qty-num');
      if (qtyEl) qtyEl.textContent = String(item.quantity);

      updateButtonsState(row, item.quantity);
      syncRowPrice(row, item);

      setRowBusy(row, false);
    });

    updateSubtotal(cart.original_total_price, !silent);
    // CART V2 — Total et chip viennent TOUJOURS du panier renvoyé par Shopify,
    // jamais d'un calcul local : c'est ce qui garantit que l'affichage ne peut
    // pas diverger du checkout.
    updateTotal(cart.total_price, !silent);
    const savings = computeSavings(cart);
    updateSavingRow('.js-cart-v1-bundle-row', '.js-cart-v1-bundle-val', savings.bundle);
    updateSavingRow('.js-cart-v1-gift-row', '.js-cart-v1-gift-val', savings.gift);
    renderCodeRows(cart);
  };

  /* ═══ MK_PERSONALIZATION 2026-08-30 ═══
     (1) ORDRE : la sous-ligne de finition se replace derrière SON tapis. /cart.items ne garantit
         pas l'ordre d'ajout (une app repose des properties sur la ligne tapis, ce qui la recrée en
         fin de liste), donc on corrige au rendu plutôt que de compter dessus.
     (2) COHÉRENCE : la finition n'existe que par son tapis. Retirer le tapis, ou le passer à 0,
         emporte la finition. Même plafond que dans le tiroir : jamais plus de lignes de finition
         que de lignes de tapis. */
  const orderPersoRows = () => {
    root.querySelectorAll('.cart-page-item--perso').forEach((addon) => {
      const target = addon.getAttribute('data-perso-for');
      let host = target ? root.querySelector('.cart-page-item[data-variant-id="' + target + '"]') : null;
      if (!host) {
        host = [...root.querySelectorAll('.cart-page-item:not(.cart-page-item--perso)')].pop();
      }
      if (host && host.nextElementSibling !== addon) host.after(addon);
    });
    // 1er nov 2026 : le chargeur offert passe sous les tapis. Il arrivait en premier (ajouté avant
    // le tapis), et sur téléphone le client voyait le cadeau avant son produit.
    root.querySelectorAll('.cart-page-item--gift').forEach((gift) => {
      const list = gift.parentElement;
      if (list && list.lastElementChild !== gift) list.appendChild(gift);
    });
  };

  const reconcilePersoRows = async (cart) => {
    let current = cart;
    for (let guard = 0; guard < 4; guard += 1) {
      const items = (current && current.items) || [];
      const addons = items.filter((i) => i.properties && i.properties._mk_perso_addon);
      const mats = items.filter((i) => !(i.properties && i.properties._mk_perso_addon)
        && String(i.product_type || '').toLowerCase() === 'car mats');
      if (addons.length <= mats.length) return current;
      const victim = addons[addons.length - 1];
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: victim.key, quantity: 0 }),
      });
      if (!response.ok) return current;
      current = await response.json();
    }
    return current;
  };

  const changeLine = async (lineKey, nextQty) => {
    const row = rowByKey(lineKey);
    setRowBusy(row, true);

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: nextQty }),
      });

      if (!response.ok) {
        throw new Error(`Cart update failed: ${response.status}`);
      }

      let cart = await response.json();
      cart = await reconcilePersoRows(cart);
      syncFromCart(cart);
      orderPersoRows();
      // P1 (2026-08-05) — la PAGE /cart devient participante du bus panier. cart-unified.js n'est PAS
      // chargé ici → sans cette émission, retirer le tapis n'aurait plus déclenché le reconciler cadeau
      // (l'ancien patch window.fetch, supprimé en P1, s'en chargeait). On émet → mk-gift retire le cadeau,
      // puis ré-émet 'gift' → le listener ci-dessous re-syncFromCart (retire la ligne cadeau du DOM).
      if (window.mkEmitCartChanged) window.mkEmitCartChanged(cart, 'cart-page');
    } catch (error) {
      console.error(error);
      try {
        const cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (cartRes.ok) {
          const latestCart = await cartRes.json();
          syncFromCart(latestCart);
        }
      } catch (syncError) {
        console.error(syncError);
      }
      if (row) setRowBusy(row, false);
    }
  };

  const applyOptimisticLineUpdate = (row, nextQty) => {
    if (!row) return;
    const qtyEl = row.querySelector('.js-cart-v1-qty-num');
    const currentQty = Number(qtyEl?.textContent || 0);
    if (currentQty === nextQty) return;

    const finalUnit = Number(row.dataset.finalUnit || 0);
    const originalUnit = Number(row.dataset.originalUnit || finalUnit);
    const compareUnit = Number(row.dataset.compareUnit || 0);

    if (qtyEl) qtyEl.textContent = String(nextQty);
    updateButtonsState(row, nextQty);

    renderLinePrices(row, finalUnit * nextQty, originalUnit * nextQty, compareUnit * nextQty);

    // Affichage optimiste. Le Subtotal est AVANT remise, il suit donc le prix unitaire
    // d'origine ; le Total est APRÈS remise, il suit le prix unitaire net. Les deux sont
    // écrasés par la réponse serveur (syncFromCart), qui reste la source de vérité.
    // Les lignes de remise, elles, ne sont JAMAIS devinées : une remise peut sauter d'un
    // coup (retrait du tapis de coffre, cadeau qui remplace le bundle) et un montant faux
    // serait pire que pas de montant.
    const qtyDelta = nextQty - currentQty;
    updateSubtotal(localSubtotalCents + qtyDelta * originalUnit);
    updateTotal(localTotalCents + qtyDelta * finalUnit);
  };

  // ── CART V2 — file d'attente debouncée pour la quantité ───────────────────
  const queueLineChange = (lineKey, nextQty) => {
    const entry = pendingQty.get(lineKey) || {};
    entry.qty = nextQty;
    if (entry.timer) window.clearTimeout(entry.timer);
    entry.timer = window.setTimeout(() => {
      pendingQty.delete(lineKey);
      changeLine(lineKey, entry.qty);
    }, QTY_DEBOUNCE_MS);
    pendingQty.set(lineKey, entry);
  };

  root.addEventListener('click', (event) => {
    const qtyBtn = event.target.closest('.js-cart-v1-qty');
    if (qtyBtn) {
      event.preventDefault();
      const lineKey = qtyBtn.dataset.lineKey;
      const row = rowByKey(lineKey);
      if (!lineKey || !row) return;

      const currentQty = Number(row.querySelector('.js-cart-v1-qty-num')?.textContent || 0);
      const delta = Number(qtyBtn.dataset.delta || 0);
      const minQty = Number(row.dataset.minQty || 1);
      const nextQty = currentQty + delta;
      // Le stepper ne descend JAMAIS sous le minimum (1 par défaut) : retirer un
      // article passe par le bouton Remove, pas par un "-" qui tomberait à 0.
      if (nextQty < minQty || nextQty === currentQty) return;

      applyOptimisticLineUpdate(row, nextQty);
      queueLineChange(lineKey, nextQty);
      return;
    }

    const removeBtn = event.target.closest('.js-cart-v1-remove');
    if (removeBtn) {
      event.preventDefault();
      const lineKey = removeBtn.dataset.lineKey;
      if (!lineKey) return;
      // Une quantité encore en attente d'envoi sur cette ligne devient caduque.
      const queued = pendingQty.get(lineKey);
      if (queued && queued.timer) window.clearTimeout(queued.timer);
      pendingQty.delete(lineKey);

      const row = rowByKey(lineKey);
      applyOptimisticLineUpdate(row, 0);
      if (row) row.remove();
      changeLine(lineKey, 0);
    }
  });

  // P1 (2026-08-05) — la page /cart ÉCOUTE le bus panier : quand mk-gift retire (ou ajuste) le cadeau
  // et ré-émet `mk:cart:changed` source:'gift', on re-synchronise les lignes depuis le panier de
  // l'événement. syncFromCart gère le RETRAIT de lignes (et recharge si panier vide). Ne ré-émet RIEN
  // → pas de boucle. (L'AJOUT d'une nouvelle ligne cadeau sur /cart est hors-scope : impossible sans ATC.)
  // FILET AU CHARGEMENT (2026-08-13) — le HTML de la page peut avoir été généré AVANT que
  // le panier ne change, et dans ce cas AUCUN événement de bus n'arrivera jamais.
  // Cas réel, reproduit : sur mobile, l'ajout au panier déclenche mk-gift.js sur la PDP,
  // puis la garde mobile navigue aussitôt vers /cart. Si la ligne cadeau est créée après la
  // génération du HTML, cette page se charge sans elle — et le pass mk-gift de la nouvelle
  // page constate simplement que le cadeau est DÉJÀ au panier, donc il ne mute rien et
  // n'émet rien. Résultat : le cadeau n'apparaissait qu'après un rafraîchissement manuel.
  // On compare donc une fois l'état rendu au panier réel, sans attendre d'événement.
  //
  // On interroge le panier NOUS-MÊMES plutôt que de lire le cache global du thème. Ce cache
  // est tenu par cart-drawer.js / mk-gift.js et sa fraîcheur ne nous appartient pas :
  // vérifié en conditions réelles, il peut dater du chargement et donc ne PAS contenir la
  // ligne cadeau qu'on cherche précisément à détecter. Comparer à une valeur périmée revient
  // à ne rien vérifier. Coût : un GET /cart.js (~2 Ko), non bloquant, après le rendu — le
  // prix d'une liste toujours conforme à ce qui est facturé, sur la page qui encaisse.
  //
  // Mode silencieux : sans dérive, cette vérification ne produit aucune pulsation visible.
  let bootstrapDone = false;
  const bootstrapCheck = () => {
    if (bootstrapDone) return;
    bootstrapDone = true;
    fetch(`${localizedCartUrl()}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .then((fresh) => { if (fresh && Array.isArray(fresh.items)) syncFromCart(fresh, { silent: true }); })
      .catch(() => {});
  };
  bootstrapCheck();

  // Retour arrière depuis le checkout : la page peut être restaurée telle quelle par le
  // bfcache, avec un panier modifié entre-temps. Même filet, même mode silencieux.
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    bootstrapDone = false;
    bootstrapCheck();
  });

  document.addEventListener('mk:cart:changed', (event) => {
    const cart = event.detail && event.detail.cart;
    if (cart) syncFromCart(cart);
  });

  // CART V2 — vignette zoom activable au clavier. mk-image-zoom.js n'écoute que
  // `click` (délégation document) : on se contente de relayer Entrée / Espace, ce
  // qui laisse le fichier partagé avec le tiroir strictement inchangé.
  root.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    const handle = event.target.closest('[data-zoom-handle]');
    if (!handle) return;
    event.preventDefault();
    handle.click();
  });

  /* ═══════════════════════════════════════════════════════════════════════
     CART V2 — barre CTA sticky mobile
     ═══════════════════════════════════════════════════════════════════════ */
  if (stickyBar) {
    // Garde-fou position:fixed. Un ancêtre portant transform / filter /
    // backdrop-filter crée un bloc conteneur : l'élément « fixed » se cale alors
    // sur cet ancêtre au lieu du viewport, et la barre se coince en plein milieu
    // de la page (piège déjà rencontré sur le bottom-sheet de la home).
    // Test : pour un élément en position:fixed, offsetParent vaut null SAUF
    // justement dans ce cas. On déplace alors l'hôte — qui porte .cart-v1-root,
    // donc le CSS scopé et les custom properties le suivent. Le bouton reste
    // relié au formulaire par son attribut form=.
    if (stickyBar.offsetParent !== null && stickyHost && document.body) {
      document.body.appendChild(stickyHost);
    }

    // La barre se montre quand le bouton Checkout en flux n'est plus visible.
    const flowCheckout = root.querySelector('.cart-page-summary .cart-checkout');
    if (flowCheckout && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      observer.observe(flowCheckout);
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════
     CART V2 — zone express : pas de « or » orphelin
     Les wallets (Shop Pay / Apple Pay / PayPal) sont injectés de façon
     asynchrone par Shopify, et ne se rendent PAS toujours dans le webview
     in-app Meta. On mesure la zone, et si elle reste vide on masque le bloc
     entier (séparateur compris). On ne masque qu'au DERNIER essai : la zone
     n'est jamais cachée puis ré-affichée, donc aucun clignotement.
     Le bouton Checkout standard n'est jamais conditionné à ce test.
     ═══════════════════════════════════════════════════════════════════════ */
  orderPersoRows();

  const expressWrap = root.querySelector('.js-cart-v1-express');
  if (expressWrap) {
    let attempts = 0;
    const checkExpress = () => {
      const holder = expressWrap.querySelector('.cart-v1-additional-checkout');
      const rendered = !!holder && holder.getBoundingClientRect().height > 4;
      attempts += 1;

      if (rendered) return;
      if (attempts >= 3) {
        expressWrap.hidden = true;
        return;
      }
      window.setTimeout(checkExpress, attempts === 1 ? 1200 : 2300);
    };
    window.requestAnimationFrame(checkExpress);
  }
})();
